import React, { useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { AddButton, CancelButton, SaveButton } from '../../../components/mui/Buttons/Buttons';
import { Form, FormikProvider, useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { createConfig, getConfiguration } from '../../../redux/features/taskManagementSlice';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { Box, MenuItem, TextField } from '@mui/material';

const CreateConfig = () => {
  const [open, setOpen] = useState(false);
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.taskManagement);
  const handleApiResponse = useHandleApiResponse();
  const formik = useFormik({
    initialValues: {
      department_id: profile.departmentId,
      type: '',
      pm_approval_needed: true,
    },
    onSubmit: (values, { resetForm }) => {
      dispatch(createConfig(values)).then((res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            setOpen(false);
            dispatch(getConfiguration(profile.departmentId));
            resetForm();
          },
          onFailed: () => {
            console.log('Something went wrong');
          },
        });
      });
    },
  });
  return (
    <GlobalDialog
      title={'Create Config'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      fullWidth
      maxWidth={'sm'}
      popupButton={
        <AddButton size={'small'} action={() => setOpen(true)}>
          Add Config
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik.values}>
            <Form onSubmit={formik.handleSubmit}>
              <TextField
                size="small"
                fullWidth
                name="type"
                select
                label="Type"
                value={formik.values.type}
                onChange={formik.handleChange}
              >
                {[
                  { id: 1, name: 'Incoming' },
                  { id: 2, name: 'Outgoing' },
                ].map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', gap: 1, pt: 2 }}>
                <CancelButton size={'small'} action={() => setOpen(false)}>
                  Cancel
                </CancelButton>
                <SaveButton disabled={loading} size={'small'} type={'submit'}>
                  {loading ? 'Please Wait...' : 'Save'}
                </SaveButton>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CreateConfig;
